const COLORS = {
  BUTTON_SECONDARY: '#05152c',
  BUTTON_PRIMARY: '#9dcbf7',
  POP: '#0e3b79',
  MAIN: '#05152c',
  SELECTED: 'white',
  SELECTED_DETAILS: '#9dcbf7',
  SUBTLE_DETAILS: '#061c3a',
  TEXT_SECONDARY: '#9dcbf7',
  TEXT_PRIMARY: '#05152c'
};

export {
  COLORS
};
